import { Bar } from "react-chartjs-2";
import { Chart, registerables } from 'chart.js';
import Login from "./login_form";
import UTILS from "../../utils/commons";
import Header from "./header";
import React, { useEffect, useState } from "react";
import ButtonCard from "./button_card";
import { useNavigate } from "react-router";
import { ApiClient } from "../../utils/api-client";
import { ShoppingBag, Blocks, Truck, Banknote, Users, BookCheck, Settings, ReceiptText, ShoppingBasket, Activity, HandCoins, BadgeCent } from "lucide-react";
import { DateTime } from "luxon";

Chart.register( ...registerables );
const Dashboard = ( props ) => {
  var navigate = useNavigate();
  var db = { payments: [], suppliers: [], products: [], users: [], transactions: [], inventory: [], customers: [], reps: [] };//storage.getItem("db");

  const [ data, setData ] = useState( db );
  const [ chartData, setChartData ] = useState( { labels: UTILS.MONTHS, datasets: [] } );
  const [ summary, setSummary ] = useState( {} );
  const [ reportPeriod, setReportPeriod ] = useState( "Week" );
  const [ showHideDatePicker, setShowHideDatePicker ] = useState( false );
  const [ customStartDate, setCustomStartDate ] = useState( "" );
  const [ customEndDate, setCustomEndDate ] = useState( "" );

  var session = window.sessionStorage;
  var loginState = ( session.getItem( "loginState" ) != null ) ? JSON.parse( session.getItem( "loginState" ) ) : null;
  if ( !loginState ) navigate( "/login", { replace: true, target: "/dashboard" } );
  const apiClient = new ApiClient( loginState ? loginState.accessToken : null );
  const role = loginState?.role;
  const isStaff = role === UTILS.STAFF;
  const isSales = role === UTILS.SALES;
  const isFinance = role === UTILS.FINANCE;
  const isAdmin = role === UTILS.ADMIN;


  const getSummaryReports = async ( options ) => {
    if ( isStaff ) {
      setSummary( {} );
      return;
    }
    const query = { ...options }
    const financeOwnerId =
      loginState?.profile?.ownerId ||
      loginState?.manager?.ownerId ||
      loginState?.ownerScopeId;
    if ( isSales ) query.profileId = loginState.profile.id;
    if ( isAdmin ) query.ownerId = loginState.id;
    if ( isFinance && financeOwnerId ) query.ownerId = financeOwnerId;
    const result = await apiClient.get( "/reports/summary", { params: query } );
    setSummary( result.data )
  }


  const handleReportPeriodChange = ( e, rp ) => {
    setReportPeriod( rp );
    if ( rp === 'Custom' ) {
      setShowHideDatePicker( true );
    } else {
      let startDate, endDate;
      const today = new Date();
      switch ( rp ) {
        case "Week":
          startDate = DateTime.fromISO( today.toISOString(), { zone: 'utc' } ).startOf( 'week' ).toJSDate();
          endDate = DateTime.fromISO( today.toISOString(), { zone: 'utc' } ).endOf( 'week' ).toJSDate();
          break;
        case "Month":
          startDate = DateTime.fromISO( today.toISOString(), { zone: 'utc' } ).startOf( 'month' ).toJSDate();
          endDate = DateTime.fromISO( today.toISOString(), { zone: 'utc' } ).endOf( 'month' ).toJSDate();
          break;
        case "Year":
          startDate = DateTime.fromISO( today.toISOString(), { zone: 'utc' } ).startOf( 'year' ).toJSDate();
          endDate = DateTime.fromISO( today.toISOString(), { zone: 'utc' } ).endOf( 'year' ).toJSDate();
          break;
      }
      getSummaryReports( { startDate, endDate } );
    }
  };

  const handleCustomDateApply = () => {
    if ( customStartDate && customEndDate ) {
      setShowHideDatePicker( false );
      getSummaryReports( { startDate: customStartDate, endDate: customEndDate } );
    }
  };


  const handleButtonCardClick = ( target ) => {
    if ( target === "sales" ) { navigate( "/transactions/new", { replace: false } ); return; }
    else navigate( "/" + target, { replace: false } );
  }
  function SummaryCard( { label, value, icon, color } ) {
    return (
      <div className={`mx-auto w-6/12 xl:w-10/12 flex items-center gap-4 p-4 rounded shadow ${color}`} style={{ minWidth: 220 }}>
        <div className="text-3xl">{icon}</div>
        <div>
          <div className="text-md font-semibold">{label}</div>
          <div className="text-lg font-bold">{value !== undefined ? value.toLocaleString() : '--'}</div>
        </div>
      </div>
    );
  }
  useEffect( () => {
    if ( loginState ) {
      getSummaryReports()
    }
    else navigate( "/login", { replace: true, target: "/dashboard" } );
  }, [] );

  return (
    <>
      <Header auth={loginState} />
      <section className="bg-white xl:w-[95%] shadow-2xl min-h-[calc(90vh-4rem)] p-6 flex flex-wrap justify-evenly items-start mt-2 mx-auto rounded-lg relative">
        {/* Modal for custom date range */}
        {showHideDatePicker && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <div className="bg-white rounded-lg shadow-lg p-8 min-w-[320px] flex flex-col gap-4 relative">
              <button className="absolute top-2 right-2 text-gray-500 hover:text-red-500 text-xl" onClick={() => setShowHideDatePicker( false )}>&times;</button>
              <h2 className="text-lg font-bold mb-2">Select Custom Date Range</h2>
              <div className="flex flex-col gap-2">
                <label htmlFor="customStartDate" className="font-medium">Start Date</label>
                <input
                  type="date"
                  id="customStartDate"
                  className="form-control"
                  value={customStartDate}
                  onChange={e => setCustomStartDate( e.target.value )}
                  max={customEndDate || undefined}
                />
              </div>
              <div className="flex flex-col gap-2">
                <label htmlFor="customEndDate" className="font-medium">End Date</label>
                <input
                  type="date"
                  id="customEndDate"
                  className="form-control"
                  value={customEndDate}
                  onChange={e => setCustomEndDate( e.target.value )}
                  min={customStartDate || undefined}
                />
              </div>
              <div className="flex gap-4 mt-4">
                <button
                  className="bg-primary-500 text-white px-4 py-2 rounded disabled:opacity-50"
                  disabled={!customStartDate || !customEndDate}
                  onClick={handleCustomDateApply}
                  type="button"
                >Apply</button>
                <button
                  className="bg-gray-300 px-4 py-2 rounded"
                  onClick={() => setShowHideDatePicker( false )}
                  type="button"
                >Cancel</button>
              </div>
            </div>
          </div>
        )}
        {isSales || isFinance || isAdmin ? <div className="w-full flex flex-col justify-center items-center p-4" id="summary-area">
          <div className="w-full flex justify-center md:justify-end p-4 space-x-4">
            {[ "Week", "Month", "Year", "Custom" ].map( ( rp ) => {
              return <span onClick={( e ) => { handleReportPeriodChange( e, rp ) }} key={rp} className={`btn px-2 py-1 ${reportPeriod === rp ? 'bg-primary-300' : 'bg-secondary-300'} rounded-lg shadow hover:bg-secondary-500 hover:text-white text-sm lg:text-xl`}>{rp}</span>
            } )}

          </div>
          <div className={`w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 ${isFinance || isAdmin ? 'xl:grid-cols-5' : 'xl:grid-cols-4'} lg:gap-8 gap-6 mb-8`}>
            <SummaryCard label="Total Revenue" value={summary.totalRevenue} icon={<Banknote className="text-green-600" />} color="bg-green-100" />
            <SummaryCard label="Credit Sales" value={summary.totalCreditSales} icon={<HandCoins className="text-blue-600" />} color="bg-blue-100" />
            {/* <SummaryCard label="Stock Value" value={summary.totalCashSales} icon={<ShoppingBasket className="text-yellow-600" />} color="bg-yellow-100" /> */}
            <SummaryCard label="Expenses" value={summary.totalExpenses} icon={<Activity className="text-red-600" />} color="bg-red-100" />
            <SummaryCard label="Total Debts" value={summary.totalUnpaidDebts} icon={<BookCheck className="text-purple-600" />} color="bg-purple-100" />
            {isAdmin || isFinance ? <SummaryCard label="Supplier Debts" value={summary.totalSupplierDebts} icon={<BadgeCent className="text-yellow-600" />} color="bg-yellow-100" /> : null}
          </div>
        </div> : null}

        <div className="w-full lg:w-10/12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 items-center my-8 mx-auto">
          {isStaff ? <>
            <ButtonCard icon={<HandCoins />} text="Expenses" onClick={() => handleButtonCardClick( "expenses" )} />
            <ButtonCard icon={<Settings />} text="Settings" onClick={() => handleButtonCardClick( "settings" )} />
          </> : null}

          {isSales ? <>
            <ButtonCard icon={<Users />} text="Customers" onClick={() => handleButtonCardClick( "customers" )} />
            <ButtonCard icon={<Blocks />} text="Inventory" onClick={() => handleButtonCardClick( "inventory" )} />
            {/* <ButtonCard icon={<ShoppingBasket />} text="Sales" onClick={() => handleButtonCardClick( "sales" )} /> */}
            <ButtonCard icon={<HandCoins />} text="Expenses" onClick={() => handleButtonCardClick( "expenses" )} />
            <ButtonCard icon={<Banknote />} text="Payments" onClick={() => handleButtonCardClick( "payments" )} />
            <ButtonCard icon={<ReceiptText />} text="Transactions" onClick={() => handleButtonCardClick( "transactions" )} />
            <ButtonCard icon={<BookCheck />} text="Report" onClick={() => handleButtonCardClick( "reports" )} />
            <ButtonCard icon={<Settings />} text="Settings" onClick={() => handleButtonCardClick( "settings" )} />
          </> : null}

          {isFinance ? <>
            <ButtonCard icon={<Users />} text="Staff" onClick={() => handleButtonCardClick( "staff" )} />
            <ButtonCard icon={<Users />} text="Customers" onClick={() => handleButtonCardClick( "customers" )} />
            <ButtonCard icon={<Blocks />} text="Inventory" onClick={() => handleButtonCardClick( "inventory" )} />
            <ButtonCard icon={<Banknote />} text="Payments" onClick={() => handleButtonCardClick( "payments" )} />
            <ButtonCard icon={<ReceiptText />} text="Transactions" onClick={() => handleButtonCardClick( "transactions" )} />
            <ButtonCard icon={<HandCoins />} text="Expenses" onClick={() => handleButtonCardClick( "expenses" )} />
            <ButtonCard icon={<Activity />} text="Tenders" onClick={() => handleButtonCardClick( "tenders" )} />
            <ButtonCard icon={<BookCheck />} text="Report" onClick={() => handleButtonCardClick( "reports" )} />
            <ButtonCard icon={<Settings />} text="Settings" onClick={() => handleButtonCardClick( "settings" )} />
          </> : null}

          {isAdmin ? <>
            <ButtonCard icon={<ShoppingBag />} text="Products" onClick={() => handleButtonCardClick( "products" )} />
            <ButtonCard icon={<Truck />} text="Suppliers" onClick={() => handleButtonCardClick( "suppliers" )} />
            <ButtonCard icon={<Users />} text="Staff" onClick={() => handleButtonCardClick( "staff" )} />
            <ButtonCard icon={<Users />} text="Customers" onClick={() => handleButtonCardClick( "customers" )} />
            <ButtonCard icon={<Blocks />} text="Inventory" onClick={() => handleButtonCardClick( "inventory" )} />
            <ButtonCard icon={<HandCoins />} text="Expenses" onClick={() => handleButtonCardClick( "expenses" )} />
            <ButtonCard icon={<Banknote />} text="Payments" onClick={() => handleButtonCardClick( "payments" )} />
            <ButtonCard icon={<ReceiptText />} text="Transactions" onClick={() => handleButtonCardClick( "transactions" )} />
            <ButtonCard icon={<Activity />} text="Tenders" onClick={() => handleButtonCardClick( "tenders" )} />
            <ButtonCard icon={<BookCheck />} text="Report" onClick={() => handleButtonCardClick( "reports" )} />
            <ButtonCard icon={<Settings />} text="Settings" onClick={() => handleButtonCardClick( "settings" )} />
          </> : null}
        </div>


      </section >
    </>
  )

}

export default Dashboard;